import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import textStyles from './textStyles';
import semanticTokens from './semanticTokens';
import colors from './colors';
import Button from './button';
import Input from './input';
import Select from './select';
import Textarea from './textarea';
import Badge from './badge';
import Link from './link';

const activeLabelStyles = {
  transform: 'scale(0.85) translateY(-12px)',
};

const theme = extendTheme({
  colors,
  textStyles,
  semanticTokens,
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg: 'body-bg',
        color: 'gray.800',
      },
      // styles for the `a`
      a: {
        _hover: {
          textDecoration: 'none',
        },
      },
    },
  },
  layerStyles: {
    notoSansTC: {
      fontFamily: 'var(--font-noto-sans-tc)',
    },
    poppins: {
      fontFamily: 'var(--font-poppins), var(--font-noto-sans-tc)',
    },
  },
  components: {
    Button,
    Input,
    Select,
    Textarea,
    Badge,
    Link,
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
              },
            },
            'label:has(+ input:not(:placeholder-shown)), label:has(+ div .react-tel-input input:not(:placeholder-shown)), label:has(+ .chakra-select__wrapper), label:has(~ textarea:not(:placeholder-shown))':
              {
                ...activeLabelStyles,
              },
            label: {
              top: 0,
              left: 0,
              zIndex: 2,
              position: 'absolute',
              pointerEvents: 'none',
              mx: '12px',
              px: '4px',
              my: '16px',
              transformOrigin: 'left top',
            },
            'label:has(+ div .react-tel-input)': {
              ml: '44px',
            },
            input: {
              h: '56px',
              pt: '16px',
            },
          },
        },
      },
    },
  },
});

export default theme;
